import PropTypes from 'prop-types'
import { Button } from '@chakra-ui/react'

export const NormalButton = ({
  children,
  isDisabled,
  color = '#222',
  p = '0px',
  width = '100%',
  height = '44px',
  fontSize = '14px',
  leftIcon,
  rightIcon,
  ...props
}) => {
  const disabledStyles = {
    bg: 'bg.tertiary',
    _hover: {
      bg: 'bg.tertiary',
    },
  }

  return (
    <Button variant="outline" disabled={isDisabled} _disabled={disabledStyles} color={color} p={p} width={width} height={height} fontSize={fontSize} {...props}>
      {leftIcon}
      {children}
      {rightIcon}
    </Button>
  )
}

NormalButton.propTypes = {
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool,
  p: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
}
